import { trackingConsentRequired } from '@gonfalon/constants/constants';

// This lists timezones of countries that require GDPR compliance.
// Included are some countries such as the UK, Switzerland, and Moldova that have data protection laws similar to GDPR
// Countries sources from https://www.gdpradvisor.co.uk/gdpr-countries
const GDPR_TIMEZONES = [
  'Africa/Ceuta',
  'Asia/Famagusta',
  'Asia/Nicosia',
  'Atlantic/Azores',
  'Atlantic/Canary',
  'Atlantic/Madeira',
  'Europe/Amsterdam',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kiev',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Monaco',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zurich',
];

export function useRequiresGDPRCompliance() {
  const ipRegionRequiresOptIn = trackingConsentRequired();
  if (ipRegionRequiresOptIn !== undefined) {
    return { requiresGDPRCompliance: ipRegionRequiresOptIn };
  }

  const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

  return { requiresGDPRCompliance: GDPR_TIMEZONES.includes(timeZone) };
}
